import { dispatchLogoutEvent } from '@/src/domains/auth/utils/logoutEventUtils'

const handleLogout = () => {
  dispatchLogoutEvent()
  localStorage.clear()
  window.location.href = '/login/'
}

export default handleLogout
